/** Подписи статусов задания (как в lk_frontend/src/components/Task.js). */

const STATUSES = {
  PENDING: 'Пока не доступно',
  AVAILABLE: 'Доступно для заполнения',
  IN_PROGRESS: 'Редактируется',
  GIVEN_TO_EXPERT: 'У эксперта',
  SENT: 'Отправлено',
  OUTDATED: 'Просрочено',
  RETURNED: 'Возвращено',
  EXPORTED_TO_EAS: 'Выгружено в ИАС',
  CHECKED: 'Проверено',
};

export function getTaskStatus(status) {
  return STATUSES[status];
}
